import { render, staticRenderFns } from "./404.vue?vue&type=template&id=4d359ca6"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"
import style0 from "./404.vue?vue&type=style&index=0&id=4d359ca6&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonSimpleBox: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/common/SimpleBox/index.vue').default})
